/**
 * @description This function is used to format tables on the FAQ page.
 * It removes all table attributes, adds Bootstrap classes, and formats the header and body rows.
 * It also removes empty paragraphs and applies specific classes to certain cells.
 *
 * Usage: In the `index.js` file, you can call this function as follows:
 *         case 'faqs':
 *            page.faqs()
 *            analytics()
 *            faqPageTables({ withoutHeader: true, withoutFooter: false })
 *            break;
 *
 * @param {Object} config - Configuration object to customize the table formatting.
 * @version 2025.04.25
 * @since 2025.04.25
 */

import { e, ee } from "commonAssets/lib/selector";

const faqPageTables = (options = {}) => {
    const config = {
        withoutHeader: false,
        ...options,
    };
    ee(".faq-container table").forEach((table) => {
        // remove all table attributes (align, border, cellspacing, cellpadding)

        table.classList.add("table", "table-bordered");

        table.removeAttribute("align");
        table.removeAttribute("border");
        table.removeAttribute("cellspacing");
        table.removeAttribute("cellpadding");

        const thead = document.createElement("thead");
        const theadRow = document.createElement("tr");
        const tbody = table.querySelector("tbody");

        table.insertBefore(thead, tbody);
        thead.appendChild(theadRow);

        let rowCount = 0;
        table.querySelectorAll("tbody tr").forEach((tr, index) => {
            // theader row
            if (rowCount === 0 && !config.withoutHeader) {
                theadRow.innerHTML = tr.innerHTML;
                theadRow.querySelectorAll("td").forEach((td) => {
                    td.removeAttribute("style");
                    td.classList.add(
                        "text-bg-dark",
                        "text-center",
                        "p-2",
                        "fw-bold"
                    );
                    td.querySelectorAll("p").forEach((p) => {
                        const text = p.textContent
                            .replace(/\u00A0/g, "")
                            .trim();
                        if (text === "") {
                            p.remove();
                        }
                        p.removeAttribute("style");
                        p.classList.add("m-0", "p-0");
                    });
                });
                tr.remove();
            } else {
                // tbody row
                tr.querySelectorAll("td").forEach((td) => {
                    if (td.textContent.trim() === "Class Counsel") {
                        td.classList.add(
                            "text-bg-dark",
                            "text-center",
                            "p-2",
                            "fw-bold"
                        );
                    }
                    td.removeAttribute("style");
                    td.classList.add("text-center", "p-2");
                    td.querySelectorAll("p").forEach((p) => {
                        const text = p.textContent
                            .replace(/\u00A0/g, "")
                            .trim();
                        if (text === "") {
                            p.remove();
                        }
                        p.removeAttribute("style");
                        p.classList.add("m-0", "p-0");
                    });
                });
            }
            rowCount++;
        });
    });
};

export { faqPageTables };
